import { initializeApp } from "firebase/app";
// 1. Add 'enableIndexedDbPersistence' to this import:
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore"; 
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDoGnWD_NPehHAuiy2d52Uxs6Rv0jSFokM",
authDomain: "standalone-teacherapp.firebaseapp.com",
projectId: "standalone-teacherapp",
storageBucket: "standalone-teacherapp.firebasestorage.app",
messagingSenderId: "75641315973",
appId: "1:75641315973:web:d42f7b994c8b175f31ffec"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// 2. Add this block to turn on the phone's local memory cache
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn("Multiple tabs open. Offline mode only works in one tab at a time.");
  } else if (err.code === 'unimplemented') {
    console.warn("This browser does not support offline storage.");
  }
});